import React from 'react';

const TABS = [
    { key: 'listings', label: 'Listings' },
    { key: 'certs', label: 'Certs' },
    { key: 'cards', label: 'Cards' },
    { key: 'orders', label: 'Orders' },
    { key: 'sets', label: 'Sets' },
    { key: 'promos', label: 'Promos' },
    { key: 'brokers', label: 'Brokers' },
    { key: 'users', label: 'Users' },
];

const AdminTabs = ({ activeTab, onChange }) => (
    <div className="admin-tabs" role="tablist">
        {TABS.map((t) => (
            <button
                key={t.key}
                role="tab"
                aria-selected={activeTab === t.key}
                className={`admin-tab${activeTab === t.key ? ' active' : ''}`}
                onClick={() => onChange(t.key)}
            >
                {t.label}
            </button>
        ))}
    </div>
);

export default AdminTabs;
export { TABS };
